
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Tag } from "lucide-react";
import AddCouponDialog from "./AddCouponDialog";
import CouponManagement from "./CouponManagement";

interface Service {
  id: string;
  name: string;
}

interface CouponsManagementSectionProps {
  providerId: string;
  services: Service[];
  onCouponUpdate: () => void;
}

const CouponsManagementSection = ({ 
  providerId, 
  services, 
  onCouponUpdate 
}: CouponsManagementSectionProps) => {
  return (
    <Card>
      <CardHeader>
        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between space-y-4 sm:space-y-0">
          <CardTitle className="flex items-center space-x-2">
            <Tag className="h-5 w-5" />
            <span>Coupons</span>
          </CardTitle>
          {services && services.length > 0 && (
            <AddCouponDialog
              providerId={providerId}
              services={services}
              onCouponAdded={onCouponUpdate}
            />
          )}
        </div>
      </CardHeader>
      
      <CardContent>
        <CouponManagement 
          providerId={providerId} 
          services={services || []}
        />
      </CardContent>
    </Card>
  );
};

export default CouponsManagementSection;
